/* Hardway theme — interactivity */
document.addEventListener('click', function (e) {
  // Mobile nav toggle
  var t = e.target.closest('[data-nav-toggle]');
  if (t) {
    var nav = document.querySelector('.site-nav');
    if (nav) nav.classList.toggle('is-open');
  }
  // FAQ accordion
  var q = e.target.closest('.faq__q');
  if (q) {
    var item = q.closest('.faq__item');
    var ans = item.querySelector('.faq__a');
    var open = item.classList.toggle('is-open');
    ans.style.maxHeight = open ? ans.scrollHeight + 'px' : 0;
  }
  // Category pill filter (visual only on storefront; links handle real nav)
  var pill = e.target.closest('.cat-pill[data-filter]');
  if (pill) {
    pill.parentElement.querySelectorAll('.cat-pill').forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');
  }
});

// Countdown timers
function startCountdown(el) {
  var target = new Date(el.dataset.deadline).getTime();
  if (isNaN(target)) {
    // default: end of today
    var d = new Date(); d.setHours(23, 59, 59, 0); target = d.getTime();
  }
  function tick() {
    var diff = Math.max(0, target - Date.now());
    var s = Math.floor(diff / 1000);
    var days = Math.floor(s / 86400); s -= days * 86400;
    var hrs = Math.floor(s / 3600); s -= hrs * 3600;
    var min = Math.floor(s / 60); var sec = s - min * 60;
    var map = { days: days, hours: hrs, minutes: min, seconds: sec };
    el.querySelectorAll('[data-unit]').forEach(function (u) {
      u.querySelector('.num').textContent = String(map[u.dataset.unit]).padStart(2, '0');
    });
  }
  tick();
  setInterval(tick, 1000);
}
document.querySelectorAll('[data-countdown]').forEach(startCountdown);

/* PDP quantity stepper + case->unit conversion */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.qty-stepper__btn');
  if (!btn) return;
  var input = btn.parentElement.querySelector('.qty-stepper__input');
  var val = parseInt(input.value, 10) || 1;
  val = Math.max(1, val + parseInt(btn.dataset.step, 10));
  input.value = val; syncBuyQty();
});
function syncBuyQty() {
  var order = document.querySelector('.pdp__order');
  var hidden = document.getElementById('buy-quantity');
  var cc = document.getElementById('case-count');
  if (!order || !hidden || !cc) return;
  var pieces = parseInt(order.dataset.pieces, 10) || 1;
  var cases = parseInt(cc.value, 10) || 1;
  hidden.value = pieces * cases;
}
document.addEventListener('input', function (e) { if (e.target.id === 'case-count') syncBuyQty(); });
document.addEventListener('DOMContentLoaded', syncBuyQty);
syncBuyQty();
